import { render, staticRenderFns } from "./AdBanner.vue?vue&type=template&id=4bb95bc3&"
import script from "./AdBanner.vue?vue&type=script&lang=ts&"
export * from "./AdBanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports